import { Mail, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { CONTACT } from "@/lib/content";
import { WhatsAppIcon, InstagramIcon } from "./Icons";
import { Logo } from "./Header";

const Item = ({ href, icon, children, testId, external }) => (
  <a href={href} {...(external && { target: "_blank", rel: "noopener noreferrer" })} className="flex items-center gap-3 text-white/80 hover:text-white transition-colors" data-testid={testId}>
    {icon}{children}
  </a>
);

export const Footer = () => (
  <footer className="bg-noir text-white" data-testid="site-footer">
    <div className="max-w-[1440px] mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-3">
      <div>
        <Logo light testId="footer-logo" />
        <p className="mt-6 font-display italic text-2xl text-white/80 max-w-xs" data-testid="footer-motto">Recibimos como en casa. Organizamos como en palacio.</p>
      </div>
      <div>
        <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-white/50 mb-5">Contacto</p>
        <div className="space-y-3 text-sm">
          <Item href={`mailto:${CONTACT.email}`} icon={<Mail className="w-4 h-4" />} testId="footer-email">{CONTACT.email}</Item>
          <Item href={CONTACT.waUrl} icon={<WhatsAppIcon className="w-4 h-4" />} testId="footer-whatsapp" external>{CONTACT.phone}</Item>
          <Item href={CONTACT.instagramUrl} icon={<InstagramIcon className="w-4 h-4" />} testId="footer-instagram" external>{CONTACT.instagram}</Item>
        </div>
      </div>
      <div>
        <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-white/50 mb-5">Partners</p>
        <p className="text-sm text-white/80 mb-5 max-w-xs" data-testid="footer-pichonteam">
          La Patrona es una casa de{" "}
          <a href={CONTACT.pichonUrl} target="_blank" rel="noopener noreferrer" className="text-white underline underline-offset-4 hover:text-rose" data-testid="footer-pichonteam-link">#PICHONTEAM Growth Partners</a>.
        </p>
        <a href={CONTACT.gatoUrl} target="_blank" rel="noopener noreferrer" className="btn-shine inline-flex items-center gap-2 rounded-full border border-white/25 px-5 py-2.5 text-sm text-white hover:bg-white/10 transition-colors" data-testid="footer-gato-link">
          El gato con copas <ArrowUpRight className="w-4 h-4" />
        </a>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/50">
        <p>© {new Date().getFullYear()} La Patrona. Todos los derechos reservados.</p>
        <p data-testid="footer-credit">Estrategia y diseño: <a href={CONTACT.pichonUrl} target="_blank" rel="noopener noreferrer" className="hover:text-white">#PICHONTEAM</a> · Crecemos contigo</p>
        <Link to="/admin" className="hover:text-white" data-testid="footer-admin-link">Acceso privado</Link>
      </div>
    </div>
  </footer>
);
